module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/bg-no.2ed98cf6.png";